'use strict';

const i18n = require('i18next');
const Marked = require('marked');
const Mn = require('backbone.marionette');
const ModalView = require('common/ui/view/modal/index');
const Dialog = require('common/util/dialog');
const GroupMemberIconView = require('common/ui/view/group/member-icon');
const GroupMemberNameView = require('common/ui/view/group/member-name');
const ReadMore = require('common/ui/view/behavior/readmore');
const CommentRepository = require('communication/domain/repository/comment');
const CommentCollectionRepository = require('communication/domain/repository/comment-collection');
const TaskUpdateService = require('communication/app/service/task/update');
const TaskDeleteService = require('communication/app/service/task/delete');
const CommentItemView = require('communication/ui/comment/view/item');
const TaskListView = require('communication/ui/view/task/list');
const Template = require('communication/ui/template/task/item.hbs');
const TaskSettingView = require('communication/ui/view/task/setting');

const TaskCommentListView = Mn.CollectionView.extend({
    childView: CommentItemView,
    childViewOptions: function() {
        return {
            showReply: false,
            inTaskComment: true,
            marked: Marked,
            context: this.getOption('context'),
            TaskListView: TaskListView
        }
    },
    childViewTriggers: {
        'reply:comment': 'reply:comment'
    },
    tagName: 'ul',
    className: 'list',
});

const AssigneeList = Mn.CollectionView.extend({
    tagName: 'span',
    childView: GroupMemberNameView
});

module.exports = Mn.View.extend({
    inCommentTask: false,
    template: Template,
    tagName: 'li',
    className: 'list-item',
    ui: {
        collapseButton: '.collapse-button',
        doneButton: '.task-done-button',
        editButton: '.task-edit-button',
        deleteButton: '.task-delete-button',
        primaryContextWrapper: '.primary-context-wrapper'
    },
    events: {
        'click @ui.collapseButton': 'toggleCollapse',
        'click @ui.doneButton': 'done',
        'click @ui.editButton': 'edit',
        'click @ui.deleteButton': 'delete'
    },
    modelEvents: {
        change: 'render',
        active: 'activate',
        inactive: 'deactivate',
    },
    regions: {
        ownerName: '.task-owner-name',
        assignee: '.task-assignee',
        additional: '.additional-view',
        taskCommentList: '.task-comment-list',
        primaryContext: '.primary-context'
    },
    childViewEvents: {
        'reply:comment': 'onReply'
    },
    collapseShown: false,

    initialize: function() {
        this._comment = null;
    },

    templateContext: function() {
        const context = this.getOption('context');
        const user = context.getUser();
        const group = context.getGroup();
        const inCommentTask = this.getOption('inCommentTask');
        return {
            isMember: group.isMember(user ? user.id : null),
            id: this.model.cid,
            isDone: this.model.isDone(),
            hasComment: inCommentTask ? false : this.model.getCommentKey()
        }
    },

    onRender: function() {
        const context = this.getOption('context');
        const project = context.getProject();

        this.showChildView('ownerName', new GroupMemberNameView({
            model: this.model.getOwner()
        }));
        this.showChildView('assignee', new AssigneeList({
            collection: new Backbone.Collection(this.model.getAssignees())
        }));

        const PrimaryContextView = this.getOption('PrimaryContextView');
        if(PrimaryContextView) {
            this.ui.primaryContextWrapper.show();
            this.showChildView('primaryContext', new PrimaryContextView({
                model: this.model,
                context: this.getOption('context')
            }));
        }

        const AdditionalView = this.getOption('AdditionalView');
        const inCommentTask = this.getOption('inCommentTask');
        if(AdditionalView && !inCommentTask) {
            this.showChildView('additional', new AdditionalView({
                model: this.model,
                context: this.getOption('context')
            }));
        }

        const commentKey = this.model.getCommentKey();
        const primaryRelatedKey = this.model.getPrimaryRelatedKey();

        const showTaskCommentList = (comment) => {
            if(!inCommentTask) {
                this.showChildView('taskCommentList', new TaskCommentListView({
                    model: this.model,
                    collection: new Backbone.Collection([comment]),
                    context: this.getOption('context')
                }));
            }
            // タスクの作成元コメントは 1 件のみ
            this._comment = comment;
        };

        if (commentKey && primaryRelatedKey) {
            // primaryRelatedKey があれば、 primaryRelatedKey のコメントライムライン上に commentKey を中心に
            // 前後数件の部分ページを取得した後に、このタスクの作成元となったコメントを表示する
            const commentCollection = CommentCollectionRepository.find(project).byKey(primaryRelatedKey);
            commentCollection.fetchPageByItemKey(commentKey)
                .then(() => {
                    // タスク作成元のコメントを表示
                    const comment = CommentRepository.find(project).get(commentKey.id);
                    if (comment) {
                        showTaskCommentList(comment);
                    }
                });
        } else if (commentKey) {
            // タスク作成元となったコメントを取得・表示
            CommentRepository.find(project).fetchByKey(this.model.key, 1, null, {flat: true})
                .then(result => {
                    const comment = result.models.length > 0 ? result.models[0] : null
                    if (comment) {
                        showTaskCommentList(comment);
                    }
                });
        }

        if(this.model.isActive()) {
            this.activate();
            this.showCollapse();
        }
    },

    toggleCollapse: function() {
        if(this.collapseShown) {
            this.hideCollapse();
        } else {
            this.showCollapse();
        }
    },

    showCollapse: function() {
        this.$('.collapse').collapse('show');
        this.$('.collapse-icon').removeClass('fa-angle-down');
        this.$('.collapse-icon').addClass('fa-angle-up');
        this.collapseShown = true;
    },

    hideCollapse: function() {
        this.$('.collapse').collapse('hide');
        this.$('.collapse-icon').removeClass('fa-angle-up');
        this.$('.collapse-icon').addClass('fa-angle-down');
        this.collapseShown = false;
    },

    done: function() {
        const project = this.getOption('context').getProject();
        const taskId = this.model.id;
        const json = {
            id: taskId,
            state: 'done'
        };

        const taskService = new TaskUpdateService(project, taskId, json);
        taskService.update();
    },

    edit: function() {
        const project = this.getOption('context').getProject();
        const taskId = this.model.id;
        const modal = new ModalView({
            title: i18n.t('communication_template:modal.task.edit-title'),
            bodyView: new TaskSettingView({
                model: this.model,
                context: this.getOption('context'),
                CommentView: this.model.getCommentKey() ? CommentItemView : false,
                comment: this._comment,
                marked: Marked,
                AdditionalView: this.getOption('AdditionalView'),
                relatedKeys: this.model.getRelatedKeys(),
                isEditing: true
            }),
            onChildviewSave: function() {
                const isValid = this.getChildView('body').model.isValid(true);
                if(!isValid) {
                    return;
                }

                this.disableButtons();
                let json = this.getChildView('body').getJSON();

                const taskService = new TaskUpdateService(project, taskId, json);
                taskService.update()
                    .then(() => {
                        this.hide();
                    });
            }
        });
        modal.show();
    },

    delete: function() {
        Dialog.confirm({
            text: i18n.t('notify.delete-confirm', {
                name: this.model.getName()
            }),
            okCallback: () => {
                this.deleting();
            }
        });
    },

    deleting: function() {
        const project = this.getOption('context').getProject();
        const taskId = this.model.id;

        const taskService = new TaskDeleteService(project, taskId);
        taskService.delete();
    },

    onReply: function(comment) {
        this.triggerMethod('reply:task', comment, this);
    },

    activate: function() {
        this.$el.addClass('is-active');
        this.triggerMethod('active', this);
    },

    deactivate: function() {
        this.$el.removeClass('is-active');
        this.triggerMethod('inactive', this);
    },
});



// WEBPACK FOOTER //
// ./communication/ui/view/task/item.js